import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  PLATFORM_ID,
  Inject
} from '@angular/core';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { LocaleService } from '@app/core/i18n';
import { ContentsService } from '@vestiaire/api-sdk-angular';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@env/environment';

@Component({
  selector: 'vc-footer-legals',
  templateUrl: './footer-legals.component.html',
  styleUrls: ['./footer-legals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterLegalsComponent implements OnInit {
  @Input()
  legals: IlegalFooter;

  @Input()
  home: boolean;

  @Input()
  showAccessibilityLink: boolean;

  defaultHost = environment.envName === 'dev' ? 'http://' : '';
  accessibilityStatementLink = this.defaultHost + environment.legacyLink + '/accessibility-statement/';
  public modifierClass = 0;
  private legalsToAnchor = ['legal-mentions'];
  private isPromo = false;

  constructor(
    private helpersService: HelpersService,
    private localeService: LocaleService,
    private contentsService: ContentsService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.contentsService.listPromotionalBanners().subscribe(
        res => {
          if (res.data && Array.isArray(res.data) && res.data.length > 0) {
            const promo = res.data[0];
            if (promo.content !== '' && promo.link) {
              this.isPromo = true;
              this.changeDetector.markForCheck();
            }
          }
        },
        () => {}
      );
    }
  }

  toggleAccordionClass(event) {
    this.modifierClass = this.helpersService.toggleAccordionOpenClass(event);
  }

  isAnchor({ obfuscate, mnemonic }) {
    return !obfuscate && this.home && this.legalsToAnchor.includes(mnemonic);
  }

  isDisplayed(legal): boolean {
    if (legal.mnemonic === 'promotional-offers-conditions') {
      return this.isPromo;
    }
    if (legal.mnemonic === 'dgccrf') {
      return this.localeService.getLanguage() === 'fr' && this.localeService.getCountry() === 'FR';
    }

    return true;
  }
}

export interface IlegalFooter {
  id: number;
  mnemonic: string;
  link: string;
  target: string;
  name: string;
  obfuscate: boolean;
}
